export default "__VITE_ASSET__0cf49588__"